<i18n
  src="@/locales/views/agro_exporter/production/query_container_quality/show_process.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/container_final_quality.yml" lang="yaml"></i18n>

<template>
  <div>
    <go-back-link
      :text="$t('labels.go_back_link')"
      :name="routeName('list_processes')"
      :params="{
        agro_exporter_id: this.agro_exporter_id
      }"
    ></go-back-link>

    <bread-crumbs :labels="[module_name, agro_exporter_process?.name]" />

    <template v-if="load_general_data">
      <tabs-container v-model="option_tabs" :with_routing="true" />

      <router-view
        :agro_exporter_process="agro_exporter_process"
        :containers="containers"
      ></router-view>
    </template>
    <loading-message v-else />
  </div>
</template>

<script>
import Requester from "@/views/agro_exporter/requesters/production/query_container_quality/show_process.js";

export default {
  name: "AEProductionQueryContainerExportShowProcess",
  components: {},
  props: ["agro_exporter_process_id", "agro_exporter_id"],
  data() {
    return {
      load_general_data: false,
      agro_exporter_process: {},
      containers: [],
      option_tabs: []
    };
  },
  computed: {
    numContainersRejected: function () {
      return this.containers.filter(
        container => container.container_final_quality?.status_id == 0
      ).length;
    },
    numContainersMediumQuality: function () {
      return this.containers.filter(
        container => container.container_final_quality?.status_id == 1
      ).length;
    },
    numContainersHighQuality: function () {
      return this.containers.filter(
        container => container.container_final_quality?.status_id == 2
      ).length;
    }
  },
  methods: {
    fetchData: async function () {
      await this.fetchAgroExporterProcess();
      await this.fetchContainers();
      this.fillOptions();
      this.load_general_data = true;
    },
    fetchAgroExporterProcess: async function () {
      let response = await Requester.fetchAgroExporterProcess(
        this.agro_exporter_id,
        this.agro_exporter_process_id
      );
      this.agro_exporter_process = response.data;
    },
    fetchContainers: async function () {
      let response = await Requester.fetchContainers(
        this.agro_exporter_id,
        this.agro_exporter_process_id
      );
      this.containers = response.data;
    },
    fillOptions: function () {
      this.option_tabs = [
        {
          name: this.$t("labels.containers_title"),
          icon: "fa-solid fa-container-storage",
          route: { name: this.routeName("show_process_containers") }
        },
        {
          name: this.$t("labels.graphics_title"),
          icon: "fa-solid fa-chart-column",
          route: { name: this.routeName("show_process_graphics") }
        }
      ];
    }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          agro_exporter_id: this.agro_exporter_id
        }
      }).then(() => this.fetchData())
    );
  }
};
</script>
